import { useTranslation } from "react-i18next";
import { ClosedCategories, saveCosedCategories } from "../utils/serialization";

interface CategoryProps {
  name: string;
  closedCategories: ClosedCategories;
  onClick: Function;
}

export function Category(props: React.PropsWithChildren<CategoryProps>) {
  const { t } = useTranslation();
  const { name, closedCategories, onClick } = props;
  const closed = closedCategories[name] === true;
  let open = !closed;
  return (
    <details className={`${name} open ${open}`} open={open}>
      <summary
        onClick={(e) => {
          e.preventDefault(); //without this the open/close functionaly becomes quirky
          const newValues = { ...closedCategories, [name]: !closed };
          saveCosedCategories(newValues);
          onClick(newValues);
        }}
      >
        {t(name)}
      </summary>

      {props.children}
    </details>
  );
}
